import type {
  CredentialResponseBase,
  LeaguePortfolioSeatPublic,
  LeagueSubmissionPublic,
  MyCreditsResponse,
  PlayerResponse,
  PolicyVersionRow,
  V2PolicyVersionRow,
} from "@softmax/observatory-client/types";

import type { PlayTransport } from "./play-transport";
export function createPlayPlayerReads(transport: PlayTransport) {
  const { playFetch, playFetchWithHeaders } = transport;
  const portfolio = (): Promise<LeaguePortfolioSeatPublic[] | null> =>
    playFetch<LeaguePortfolioSeatPublic[]>({
      path: "/v2/league-policy-memberships/portfolio",
    });
  const mySubmissions = ({
    leagueId,
  }: {
    leagueId?: string;
  }): Promise<LeagueSubmissionPublic[] | null> => {
    const query = new URLSearchParams({ mine: "true" });

    if (leagueId) query.set("league_id", leagueId);

    return playFetch<LeagueSubmissionPublic[]>({
      path: `/v2/league-submissions?${query.toString()}`,
    });
  };
  const myPolicyVersions = async (): Promise<{
    rows: V2PolicyVersionRow[];
    nextCursor: string | null;
  } | null> => {
    const page = await playFetchWithHeaders<V2PolicyVersionRow[]>({
      path: "/v2/policy-versions?mine=true&limit=200",
    });

    if (!page) return null;

    return { rows: page.body, nextCursor: page.headers.get("X-Next-Cursor") };
  };
  const credits = (): Promise<MyCreditsResponse | null> => {
    return playFetch<MyCreditsResponse>({
      path: "/usage/me/credits",
    });
  };
  const myPlayers = (): Promise<PlayerResponse[] | null> => {
    return playFetch<PlayerResponse[]>({
      path: "/players",
    });
  };
  const policyVersionDetail = (
    policyVersionId: string,
  ): Promise<PolicyVersionRow | null> =>
    playFetch<PolicyVersionRow>({
      path: `/stats/policy-versions/${encodeURIComponent(policyVersionId)}`,
    });
  const credentials = (): Promise<CredentialResponseBase[] | null> => {
    return playFetch<CredentialResponseBase[]>({
      path: "/credentials",
    });
  };
  return {
    portfolio,
    mySubmissions,
    myPolicyVersions,
    credits,
    myPlayers,
    policyVersionDetail,
    credentials,
  };
}
